/**
Author - Babajan
Github - https://www.github.com/babajanpatan/
**/

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";


import {
  SelectCity
} from "components/commons";

import Dropdown from "../Dropdown";

import CheckboxDropdown from "../CheckboxDropdown";

const propTypes = {
  formData: PropTypes.object.isRequired,
  indianCityList: PropTypes.array.isRequired,
  isARNinput: PropTypes.bool.isRequired,
  isCustomAnswerRequired: PropTypes.bool.isRequired,
  isSelectCityRequired: PropTypes.bool.isRequired,
  isUpdatingAnswer: PropTypes.bool.isRequired,
  onSelectedCityClick: PropTypes.func.isRequired,
  question: PropTypes.array.isRequired,
  questionTitle: PropTypes.string.isRequired,
  selectedOption: PropTypes.any.isRequired,
  setFormData: PropTypes.func.isRequired
};

const CardDetails = ({
  formData,
  isARNinput,
  indianCityList,
  onSelectedCityClick,
  isUpdatingAnswer,
  question,
  questionTitle,
  setFormData,
  isCustomAnswerRequired,
  selectedOption,
  isSelectCityRequired
}) => {
  const activeOptionsContent = question.options.map((option, index) => {
    return (
      <li
        className="dropdown-menu__item"
        key={index}
        onClick={() => {
          setFormData({
            ...formData,
            [question.externalId]: {
              answer: option.externalId,
              qnaStage: question.externalId,
              customAnswer: isCustomAnswerRequired ? option.externalId : "",
              displayTitle: option.answer
            }
          });
        }}
      >
        {option.answer}
      </li>
    );
  });

  const renderAnswerInput = () => {
    return isARNinput ? (
     <>
       <ARNInputWrapper>
         <ARNLabel>ARN - </ARNLabel>
         <InputContainer
           placeholder={question?.question?.placeholder}
           type="text"
           onChange={(e) => {
             const inputValue = e.target.value;
             setFormData({
               ...formData,
               [question.externalId]: {
                 answer: "",
                 qnaStage: question.externalId,
                 customAnswer: inputValue,
                 displayTitle: inputValue
               }
             });
           }}
         />
       </ARNInputWrapper>
     </>
    ) : (
      <InputContainer
        placeholder={question?.question?.placeholder}
        type="text"
        onChange={(e) => {
          const inputValue = e.target.value;
          setFormData({
            ...formData,
            [question.externalId]: {
              answer: "",
              qnaStage: question.externalId,
              customAnswer: inputValue,
              displayTitle: inputValue
            }
          });
        }}
      />
    );
  };

  return (
    <Wrapper>
      {
        isSelectCityRequired ? (
          <SelectCityWrapper>
            <QuestionText>{questionTitle}</QuestionText>
            <SelectCity
              alreadySelectedCity={selectedOption}
              cityList={indianCityList}
              onSelectedCityClick={onSelectedCityClick}
            />
          </SelectCityWrapper>
        ) : question.multiSelect ?
          <DropdownWrapper>
            <QuestionText>{questionTitle}</QuestionText>
            <CheckboxDropdown
              externalId={formData[question.externalId]}
              formData={formData}
              isUpdatingAnswer={isUpdatingAnswer}
              options={question.options.map((option) => ({
                label: option.answer,
                value: option.externalId
              }))}
              question={question}
              selectedOption={selectedOption}
              setFormData={setFormData}
              title={selectedOption?.length > 0 ? selectedOption : question.question.placeholder}
            />
          </DropdownWrapper>
          : isCustomAnswerRequired ? (
            <>
              <QuestionText>{questionTitle}</QuestionText>
              {renderAnswerInput()}
            </>
          ) : (
            <DropdownWrapper>
              <QuestionText>{questionTitle}</QuestionText>
              <Dropdown
                options={activeOptionsContent}
                title={selectedOption?.length > 0 ? selectedOption : question?.question.placeholder}
              />
            </DropdownWrapper>
          )
      }
    </Wrapper>
  );
};

const Wrapper = styled.div``;

const DropdownWrapper = styled.div``;

const QuestionText = styled.p`
  width: 80%;
  margin: 0 auto 1rem auto;
  font-size: 1.8rem;
  text-align: left;
  line-height: 1.43;
  white-space: pre-line;

  @media (max-width: 768px) {
    width: 95%;
    margin-left: auto;
    margin-right: auto;
  }
`;

const SelectCityWrapper = styled.div`
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 2;
`;

const InputContainer = styled.input`
  position: relative;
  display: flex;
  padding: 1rem 2.4rem;
  width: 89%;
  /* margin: 0 auto 3rem; */
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-radius: 1.2rem;
  height: 5rem;
  box-shadow: 4px 4px 20px rgb(0 0 0 / 15%);
  font-weight: 500;
   border: none;
  transition: all 0.2s ease-in-out;

  :focus {
    box-shadow: 4px 4px 20px rgb(0 0 0 / 25%);
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 4.5rem;
  }

  @media (max-height: 660px) {
    height: 4.5rem;
  }

  @media (max-height: 600px) {
    height: 4.5rem;
  }
`;

const ARNInputWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1rem;
  width: 80%;
  margin: 0 auto 3rem;
`;

const ARNLabel = styled.span`
  font-size: 1.8rem;
  font-weight: 600;
  text-align: left;
  margin-top: 0.7rem;
`;

CardDetails.propTypes = propTypes;

export default CardDetails;
